import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet';

import QuoteDetail from "../components/quoteDetail/QuoteDetail";
import translations from "../translations/confirmation";
import quoteTranslations from "../translations/quote-form";
import headerTranslations from "../components/header/header-translations";
import { PhoneIcon } from "../components/articlesList/BlogIcons";

const Confirmation = (props) => {

  let location = useLocation();
  let navigate = useNavigate();

  if(location.state==null){
    console.log(location.state, 'redirecting')
    return navigate((props.lang==='fr'?'':'/'+props.lang)+"/devis-reservation-vtc/");
  }

  let quote = location.state;

  var domain = quote.email.split("@")[1][0];
  var dI = quote.email.split("@")[1].split(".")[0].length;
  for (var i = 0; i < dI - 1; i++) {
    domain += "*";
  }
  domain += "." + quote.email.split("@")[1].split(".")[1];
  var user = quote.email.split("@")[0][0];
  var uI = quote.email.split("@")[0].length;
  for (var j = 0; j < uI - 1; j++) {
    user += "*";
  }
  quote.emailObs = user + "@" + domain;

  const t = translations[props.lang];
  const steps = quoteTranslations[props.lang];

  return (
    <div className="quote">
      <Helmet>
        <title>{t.meta.title}</title>
        <meta name="description" content={t.meta.description}/>
      </Helmet>
      <div className="pay-page">
        <div className="quote-intro">
          <span className="eyebrow">{t.eyebrow}</span>
          <h1>{t.head}</h1>
          <p className="lead">{t.thanks} {t.email} <strong>{quote.emailObs}</strong>.</p>
        </div>
        <div className="pay-layout">
          <div className="pay-summary">
            <QuoteDetail lang={props.lang} quote={quote} />
          </div>
          <aside className="quote-aside">
            <div className="quote-aside-card">
              <h2>{steps.stepsTitle}</h2>
              <ol className="quote-steps">
                {steps.steps.map((step) => (
                  <li key={step.title}>
                    <strong>{step.title}</strong>
                    <span>{step.text}</span>
                  </li>
                ))}
              </ol>
            </div>
            <div className="pay-help">
              <strong>{t.spam}</strong>
              <a href="tel:+33660265336"><PhoneIcon />{headerTranslations[props.lang].phone}</a>
              <a href="mailto:contact@davoyage.com">contact@davoyage.com</a>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
